import $ from 'jquery';

export const isOrientationFormatSelectedFromSelect = () => {
  const selectValue = $('#formats-select-orientation').val();
  if (selectValue !== null) {
    return true;
  }
};
